import { render, staticRenderFns } from "./CourseEdit.vue?vue&type=template&id=5db370cf&scoped=true&"
import script from "./CourseEdit.vue?vue&type=script&lang=js&"
export * from "./CourseEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5db370cf",
  null
  
)

export default component.exports